import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Col, Container, Row } from "react-bootstrap";
// import { Country } from "../../../../../../shared/constants/Constant";
// import { useAppUser } from "../../../../../../contexts/user-context/UserContext";
import { useFirestore, useFunctions, useStorage } from "reactfire";

import { useHistory, useLocation, useParams } from "react-router-dom";
import defautUserImage from "../../../../../../shared/resources/default-company-logo.png";
import { FaPencilAlt } from "react-icons/fa";
import random from "randomstring";
import ConfirmationModal from "../../../../../../shared/components/confirmationModal/ConfirmationModal";
import FormValidator from "../../../../../../shared/utils/FormValidator";
import IndustryTag from "../../components/industryTag/WorkshopTag";
import { DashboardTeamsPages } from "../TeamRoutes";
import PageHeader from "../../../../components/page-header/PageHeader";
import UserNotification from "../../../../../../shared/components/Notification/UserNotification";
import FounderForm from "../../components/founder-form/FounderForm";
import { DashboardAccountsPages } from "../../../account/containers/Account";

/**
 *
 * Profile Information
1. Logo
2. Industry tags
3. Founded
4. Country
5. Social media links
6. Company Name
7. One line introduction
8. Company overview
9. Separate the section & Add profile pic Name, Title, Description
10. Last edited by Admin/Moderator/Member - <Name>
 */

export enum IndustryTags {
  Agriculture = "Agriculture",
  ECommerce = "ECommerce",
  EdTech = "EdTech",
  FinTech = "FinTech",
  Health = "Health",
  Logistics = "Logistics",
  Media_Branding = "Media/Branding",
  Retail = "Retail",
  Power = "Power",
  Social = "Social",
  Travel_and_Hospitality = "Travel and Hospitality",
  Robotics = "Robotics",
  Information_Sciences = "Information Sciences",
  Others = "Others",
}

export interface TeamData {
  id?: string;
  logo?: string;
  industryTags?: IndustryTags[];
  founded?: string;
  facebook?: string;
  linkedIn?: string;
  twiter?: string;
  youtube?: string;
  website?: string;
  instagram?: string;
  companyName?: string;
  oneLineIntro?: string;
  overview?: string;
  founders?: Founder[];
  updatedByUserName?: string;
  isPublished?: boolean;
}

export interface Founder {
  imageUrl: string;
  title: string;
  name: string;
  description: string;
}

export interface FounderWithFile extends Founder {
  file?: File;
  nameError: string;
  imageError: string;
  titleError: string;
  descriptionError: string;
  imagePreview: any;
}

const initialFounder: FounderWithFile = {
  imageUrl: "",
  title: "",
  name: "",
  nameError: "",
  description: "",
  imageError: "",
  titleError: "",
  descriptionError: "",
  imagePreview: "",
};

interface Errors {
  logoError: string;
  industryTagsError: string;
  foundedError: string;
  facebookError: string;
  linkedInError: string;
  twiterError: string;
  youtubeError: string;
  websiteError: string;
  instagramError: string;
  companyNameError: string;
  onLineIntroError: string;
  overviewError: string;
}

const initErrors: Errors = {
  logoError: "",
  industryTagsError: "",
  foundedError: "",
  facebookError: "",
  linkedInError: "",
  twiterError: "",
  websiteError: "",
  instagramError: "",
  youtubeError: "",
  companyNameError: "",
  onLineIntroError: "",
  overviewError: "",
};

interface State {
  showAcceptConfirmation: boolean;
  showPublishConfirmation: boolean;
}

const initState: State = {
  showAcceptConfirmation: false,
  showPublishConfirmation: false,
};

const initTeam: TeamData = {
  companyName: "",
  founded: "",
  id: "",
  industryTags: [],
  logo: "",
  oneLineIntro: "",
  overview: "",
  isPublished: true,
  facebook: "",
  linkedIn: "",
  twiter: "",
  youtube: "",
};

const TeamProfileEditComponent = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  const parums = useParams() as any;
  const storage = useStorage().ref();
  const store = useFirestore();
  const [team, setTeam] = useState(initTeam);
  const [errorState, setErrorState] = useState(initErrors);
  const [state, setState] = useState(initState);
  const [loading, setLoading] = useState(false);
  const [fileInput, setFileInput] = useState<any>(null);
  const [companyLogo, setCompanyLogo] = useState<{
    file: File | null;
    preview: any;
  }>({ file: null, preview: null });

  const [founders, setFounders] = useState<FounderWithFile[]>([]);

  // const [selectedIndustryTag, setSelectedIndutryTag] = useState<IndustryTags>();

  const updateTeamProfileRef = useFunctions().httpsCallable(
    "updateTeamProfile"
  );

  //get team data
  useEffect(() => {
    store
      .collection("teams")
      .doc(parums.id)
      .onSnapshot((snap) => {
        const data = snap.data() as TeamData;
        setTeam({
          id: snap.id,
          logo: data.logo || "",
          industryTags: data.industryTags || [],
          founded: data.founded || "",
          facebook: data.facebook || "",
          linkedIn: data.linkedIn || "",
          twiter: data.twiter || "",
          youtube: data.youtube || "",
          website: data.website || "",
          instagram: data.instagram || "",
          companyName: data.companyName || "",
          oneLineIntro: data.oneLineIntro || "",
          overview: data.overview || "",
          founders: data.founders || [],
          updatedByUserName: data.updatedByUserName,
          isPublished: data.isPublished,
        });
        setFounders(
          data.founders?.map((f) => ({ ...initialFounder, ...f })) || []
        );
        setCompanyLogo((ps) => ({ ...ps, preview: data.logo }));
      });
  }, [parums.id, store]);

  const validateData = (): boolean => {
    // return false;
    const companyNameValidation = FormValidator.validateString(
      team.companyName,
      "Company name",
      3,
      100
    );
    const foundedValidation = FormValidator.validateString(
      team.founded,
      "Founded year",
      3,
      4
    );
    const oneLineIntroValidation = FormValidator.validateString(
      team.oneLineIntro,
      "One line introduction",
      3,
      100
    );
    const overviewValidation = FormValidator.validateString(
      team.overview,
      "Company overview",
      3,
      3000
    );
    const logoValidation =
      team.logo || companyLogo.file
        ? { isValid: true, message: "" }
        : { isValid: false, message: "Company logo required" };
    const industryTagsValidation = team.industryTags
      ? team.industryTags.length <= 0
        ? { isValid: false, message: "Invalid industry tags" }
        : { isValid: true, message: "" }
      : { isValid: false, message: "Invalid industry tags" };

    //validate founder array
    const founderValidation = founders
      .map((f, index) => {
        const titleValidation = FormValidator.validateString(
          f.title,
          "Title",
          3,
          100
        );
        const nameValidation = FormValidator.validateString(
          f.name,
          "Name",
          3,
          100
        );
        const descriptionValidation = FormValidator.validateString(
          f.description,
          "Description",
          3,
          2000
        );
        const imageValidation =
          f.imageUrl || f.file
            ? { isValid: true, message: "" }
            : { isValid: false, message: "Image required" };

        setFounders((ps) => {
          const founder = ps[index];
          founder.titleError = titleValidation.message;
          founder.descriptionError = descriptionValidation.message;
          founder.imageError = imageValidation.message;
          founder.nameError = nameValidation.message;
          return [...ps];
        });
        return (
          titleValidation.isValid &&
          descriptionValidation.isValid &&
          nameValidation.isValid &&
          imageValidation.isValid
        );
      })
      .every((b) => b === true);

    setErrorState({
      ...errorState,
      logoError: logoValidation.message,
      industryTagsError: industryTagsValidation.message,
      foundedError: foundedValidation.message,
      companyNameError: companyNameValidation.message,
      onLineIntroError: oneLineIntroValidation.message,
      overviewError: overviewValidation.message,
    });

    return (
      companyNameValidation.isValid &&
      foundedValidation.isValid &&
      oneLineIntroValidation.isValid &&
      overviewValidation.isValid &&
      logoValidation.isValid &&
      industryTagsValidation.isValid &&
      founderValidation
    );
  };

  const saveTeamData = async (isPublished: boolean) => {
    setLoading(true);

    const promises = founders
      .filter((f) => f.file)
      .map(async (f) => {
        if (f.file) {
          const uploadTask = storage
            .child(
              `profilePictures/founder-${random.generate(10)}.${f.file.name
                .split(".")
                .pop()
                ?.toLowerCase()}`
            )
            .put(f.file);
          const snap = await uploadTask;
          const url = await snap.ref.getDownloadURL();
          return {
            ...f,
            imageUrl: url,
          };
        } else {
          return { ...f };
        }
      });

    let uploadTask = undefined;
    if (companyLogo.file) {
      uploadTask = storage
        .child(
          `profilePictures/teamlogo-${random.generate(10)}.${companyLogo?.file
            ?.name ||
            ""
              .split(".")
              .pop()
              ?.toLowerCase()}`
        )
        .put(companyLogo.file);
    }
    try {
      let url = undefined;
      if (uploadTask) {
        const snapshot = await uploadTask;
        url = await snapshot.ref.getDownloadURL();
      }

      const uploadedFounders = await Promise.all(promises);
      const savedFounders = founders.filter((f) => f.file === undefined);
      const teamData = {
        id: team.id,
        logo: url || team.logo,
        industryTags: team.industryTags,
        founded: team.founded,
        facebook: team.facebook,
        linkedIn: team.linkedIn,
        twiter: team.twiter,
        youtube: team.youtube,
        website: team.website,
        instagram: team.instagram,
        companyName: team.companyName,
        oneLineIntro: team.oneLineIntro,
        overview: team.overview,
        isPublished: isPublished ? true : team.isPublished,
        founders: [...uploadedFounders, ...savedFounders].map((f) => ({
          imageUrl: f.imageUrl,
          title: f.title,
          description: f.description,
          name: f.name,
        })),
      };

      updateTeamProfileRef(teamData)
        .then((data) => {
          setLoading(false);
          setState({
            ...state,
            showAcceptConfirmation: false,
            showPublishConfirmation: false,
          });
          UserNotification({
            isSuccess: true,
            message: isPublished
              ? "Team profile published."
              : "Team profile updated.",
          });
          if (isPublished) setTeam((ps) => ({ ...ps, isPublished: true }));

          // history.push(DashboardPages.ACCOUNT);
        })
        .catch((error) => {
          setLoading(false);
          setState({
            ...state,
            showAcceptConfirmation: false,
            showPublishConfirmation: false,
          });
          UserNotification({
            isSuccess: false,
            message: isPublished
              ? "Team profile published failed."
              : "Team profile updated failed.",
          });
        });
    } catch (error) {
      setLoading(false);
      setState({
        ...state,
        showAcceptConfirmation: false,
        showPublishConfirmation: false,
      });
      UserNotification({
        isSuccess: false,
        message: isPublished
          ? "Team profile published failed."
          : "Team profile updated failed.",
      });
    }
  };

  const itEnumToList = (object: any) => {
    return Object.keys(object).map((key) => object[key] as string);
  };

  const buttonSet = (
    <Row>
      <Col xs={12} className="text-right mb-3">
        <div
          className="cancel-button blue"
          style={{ marginRight: "15px" }}
          onClick={() => {
            console.log(
              pathname,
              DashboardAccountsPages.ACCOUNT_COMPANY.replace(":id", "")
            );
            if (
              pathname.includes(
                DashboardAccountsPages.ACCOUNT_COMPANY.replace(":id", "")
              )
            ) {
              history.push(
                DashboardAccountsPages.TEAM_PROFILE_ACCOUNT.replace(
                  ":id",
                  parums.id
                )
              );
            } else {
              history.push(DashboardTeamsPages.TEAMS);
            }
          }}
        >
          Cancel
        </div>

        {team && !team.isPublished ? (
          <div
            className="save-button"
            style={{ marginLeft: "15px" }}
            onClick={() => {
              setState((ps) => ({ ...ps, showPublishConfirmation: true }));
            }}
          >
            Publish
          </div>
        ) : (
          <></>
        )}
        <div
          className="save-button"
          style={{ marginLeft: "15px" }}
          onClick={() => {
            validateData() &&
              setState({ ...state, showAcceptConfirmation: true });
          }}
        >
          Update
        </div>
      </Col>
    </Row>
  );

  return (
    <>
      <PageHeader
        title="Update Team Profile"
        showBackButton={false}
        sidebarOnly={true}
      />
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
          color: "grey",
        }}
      >
        <Row>
          <Col xs={12}>{buttonSet}</Col>
        </Row>
        <Row>
          <Col xs={12} xl={7} lg={7} style={{ paddingRight: "3rem" }}>
            <Row>
              <div
                className="mt-3 d-flex justify-content-center p-0 mb-3"
                style={{ flex: 1 }}
              >
                <div className="d-flex justify-content-center">
                  <div>
                    <div
                      className="profile-image-v"
                      onClick={() => fileInput?.click()}
                    >
                      <div className="shade d-flex justify-content-center align-items-start pt-2">
                        <FaPencilAlt />
                      </div>
                      <img
                        src={
                          companyLogo.preview
                            ? companyLogo.preview
                            : defautUserImage
                        }
                        alt=""
                      />
                    </div>
                    <div className="text-center">
                      <label className="error-message">
                        {errorState.logoError}
                      </label>
                    </div>
                  </div>
                </div>

                <input
                  ref={(input) => setFileInput(input)}
                  className="d-none"
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const files = e.target.files;
                    if (files) {
                      try {
                        let reader = new FileReader();
                        let file = files[0];
                        reader.onloadend = () => {
                          setCompanyLogo({
                            preview: reader.result,
                            file: file,
                          });
                        };
                        reader.readAsDataURL(file);
                      } catch (error) {}
                      setErrorState((ps) => ({ ...ps, logoError: "" }));
                    }
                  }}
                />
              </div>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12} xl={7} lg={7} style={{ paddingRight: "3rem" }}>
            <Row>
              <div
                className="mt-3 p-0 pl-2"
                style={{ minWidth: "185px", lineHeight: "40px" }}
              >
                <p>
                  <strong>
                    Team Name
                    <span className="ml-1" style={{ color: "red" }}>
                      *
                    </span>
                  </strong>
                </p>
              </div>
              <div
                className="mt-3 d-flex align-content-center p-0"
                style={{ flex: 1 }}
              >
                <div
                  className="d-flex align-content-center"
                  style={{ lineHeight: "40px" }}
                >
                  <strong> : </strong>
                </div>
                <div
                  className="d-flex align-content-center"
                  style={{ marginLeft: "10px", lineHeight: "27px", flex: 1 }}
                >
                  <div className="w-100">
                    <input
                      value={team.companyName || ""}
                      onChange={(e) => {
                        setTeam({ ...team, companyName: e.target.value });
                        setErrorState({ ...errorState, companyNameError: "" });
                      }}
                      className={
                        errorState.companyNameError.length < 1
                          ? "app-input"
                          : "app-input-profile invalid"
                      }
                    />
                    <label className="error-message">
                      {errorState.companyNameError}
                    </label>
                  </div>
                </div>
              </div>
            </Row>
            <Row>
              <div
                className="p-0 pl-2"
                style={{ minWidth: "180px", lineHeight: "40px" }}
              >
                <p>
                  <strong>
                    One Line Introduction
                    <span className="ml-1" style={{ color: "red" }}>
                      *
                    </span>
                  </strong>
                </p>
              </div>
              <div
                className="d-flex align-content-center p-0"
                style={{ flex: 1 }}
              >
                <div
                  className="d-flex align-content-center"
                  style={{ lineHeight: "40px" }}
                >
                  <strong> : </strong>
                </div>
                <div
                  className="d-flex align-content-center"
                  style={{ marginLeft: "10px", lineHeight: "27px", flex: 1 }}
                >
                  <div className="w-100">
                    <input
                      value={team.oneLineIntro || ""}
                      className={
                        errorState.onLineIntroError.length < 1
                          ? "app-input-profile"
                          : "app-input-profile invalid"
                      }
                      onChange={(e) => {
                        setTeam({
                          ...team,
                          oneLineIntro: e.target.value,
                        });
                        setErrorState({
                          ...errorState,
                          onLineIntroError: "",
                        });
                      }}
                    />
                    <label className="error-message">
                      {errorState.onLineIntroError}
                    </label>
                  </div>
                </div>
              </div>
            </Row>
            <Row>
              <div
                className="p-0 pl-2"
                style={{ minWidth: "180px", lineHeight: "40px" }}
              >
                <p>
                  <strong>
                    Industry tags
                    <span className="ml-1" style={{ color: "red" }}>
                      *
                    </span>
                  </strong>
                </p>
              </div>
              <div
                className="d-flex align-content-center p-0"
                style={{ flex: 1 }}
              >
                <div
                  className="d-flex align-content-center"
                  style={{ lineHeight: "40px" }}
                >
                  <strong> : </strong>
                </div>
                <div
                  className="d-flex align-content-center"
                  style={{
                    marginLeft: "10px",
                    lineHeight: "27px",
                    flex: 1,
                  }}
                >
                  <div className="w-100">
                    <select
                      onChange={(e) => {
                        setTeam((ps) => {
                          const [available] = ps.industryTags?.filter(
                            (it) => it === (e.target.value as IndustryTags)
                          ) || [undefined];
                          if (!available)
                            ps.industryTags?.push(
                              e.target.value as IndustryTags
                            );
                          return { ...ps };
                        });
                        setErrorState({
                          ...errorState,
                          industryTagsError: "",
                        });
                      }}
                      className={
                        errorState.industryTagsError.length < 1
                          ? "app-input-profile"
                          : "app-input-profile invalid"
                      }
                    >
                      <option disabled selected>
                        Select
                      </option>
                      {itEnumToList(IndustryTags).map((tag, index) => (
                        <option key={index}>{tag}</option>
                      ))}
                    </select>
                    <div className="available-tags">
                      {team.industryTags?.map((tag, index) => {
                        return (
                          <IndustryTag
                            key={index}
                            value={tag}
                            onClose={(value) => {
                              setTeam((ps) => {
                                ps.industryTags = ps.industryTags?.filter(
                                  (it) => it !== value
                                );
                                return {
                                  ...ps,
                                  industryTags: ps.industryTags
                                    ? [...ps.industryTags]
                                    : [],
                                };
                              });
                            }}
                          />
                        );
                      })}
                    </div>
                    <label className="error-message">
                      {errorState.industryTagsError}
                    </label>
                  </div>
                </div>
              </div>
            </Row>
            <Row>
              <div
                className="p-0 pl-2"
                style={{ minWidth: "180px", lineHeight: "40px" }}
              >
                <p>
                  <strong>
                    Founded
                    <span className="ml-1" style={{ color: "red" }}>
                      *
                    </span>
                  </strong>
                </p>
              </div>
              <div
                className="d-flex align-content-center p-0"
                style={{ flex: 1 }}
              >
                <div
                  className="d-flex align-content-center"
                  style={{ lineHeight: "40px" }}
                >
                  <strong> : </strong>
                </div>
                <div
                  className="d-flex align-content-center"
                  style={{
                    marginLeft: "10px",
                    lineHeight: "27px",
                    flex: 1,
                  }}
                >
                  <div className="w-100">
                    <input
                      value={team.founded || ""}
                      type="number"
                      max={4}
                      onChange={(e) => {
                        setTeam({
                          ...team,
                          founded: e.target.value,
                        });
                        setErrorState({
                          ...errorState,
                          foundedError: "",
                        });
                      }}
                      className={
                        errorState.foundedError.length < 1
                          ? "app-input"
                          : "app-input-profile invalid"
                      }
                    />
                    <label className="error-message">
                      {errorState.foundedError}
                    </label>
                  </div>
                </div>
              </div>
            </Row>

            <Row>
              <div
                className="p-0 pl-2"
                style={{ minWidth: "180px", lineHeight: "40px" }}
              >
                <p>
                  <strong>Facebook Link</strong>
                </p>
              </div>
              <div
                className="d-flex align-content-center p-0"
                style={{ flex: 1 }}
              >
                <div
                  className="d-flex align-content-center"
                  style={{ lineHeight: "40px" }}
                >
                  <strong> : </strong>
                </div>
                <div
                  className="d-flex align-content-center"
                  style={{
                    marginLeft: "10px",
                    lineHeight: "27px",
                    flex: 1,
                  }}
                >
                  <div className="w-100">
                    <input
                      value={team.facebook || ""}
                      onChange={(e) => {
                        setTeam({
                          ...team,
                          facebook: e.target.value,
                        });
                        setErrorState({
                          ...errorState,
                          overviewError: "",
                        });
                      }}
                      className={
                        errorState.facebookError.length < 1
                          ? "app-input"
                          : "app-input-profile invalid"
                      }
                    />
                    <label className="error-message">
                      {errorState.facebookError}
                    </label>
                  </div>
                </div>
              </div>
            </Row>

            <Row>
              <div
                className="p-0 pl-2"
                style={{ minWidth: "180px", lineHeight: "40px" }}
              >
                <p>
                  <strong>LinkedIn Link</strong>
                </p>
              </div>
              <div
                className="d-flex align-content-center p-0"
                style={{ flex: 1 }}
              >
                <div
                  className="d-flex align-content-center"
                  style={{ lineHeight: "40px" }}
                >
                  <strong> : </strong>
                </div>
                <div
                  className="d-flex align-content-center"
                  style={{
                    marginLeft: "10px",
                    lineHeight: "27px",
                    flex: 1,
                  }}
                >
                  <div className="w-100">
                    <input
                      value={team.linkedIn || ""}
                      onChange={(e) => {
                        setTeam({
                          ...team,
                          linkedIn: e.target.value,
                        });
                        setErrorState({
                          ...errorState,
                          linkedInError: "",
                        });
                      }}
                      className={
                        errorState.linkedInError.length < 1
                          ? "app-input"
                          : "app-input-profile invalid"
                      }
                    />
                    <label className="error-message">
                      {errorState.linkedInError}
                    </label>
                  </div>
                </div>
              </div>
            </Row>

            <Row>
              <div
                className="p-0 pl-2"
                style={{ minWidth: "180px", lineHeight: "40px" }}
              >
                <p>
                  <strong>Twitter Link</strong>
                </p>
              </div>
              <div
                className="d-flex align-content-center p-0"
                style={{ flex: 1 }}
              >
                <div
                  className="d-flex align-content-center"
                  style={{ lineHeight: "40px" }}
                >
                  <strong> : </strong>
                </div>
                <div
                  className="d-flex align-content-center"
                  style={{
                    marginLeft: "10px",
                    lineHeight: "27px",
                    flex: 1,
                  }}
                >
                  <div className="w-100">
                    <input
                      value={team.twiter || ""}
                      onChange={(e) => {
                        setTeam({
                          ...team,
                          twiter: e.target.value,
                        });
                        setErrorState({
                          ...errorState,
                          twiterError: "",
                        });
                      }}
                      className={
                        errorState.twiterError.length < 1
                          ? "app-input"
                          : "app-input-profile invalid"
                      }
                    />
                    <label className="error-message">
                      {errorState.twiterError}
                    </label>
                  </div>
                </div>
              </div>
            </Row>

            <Row>
              <div
                className="p-0 pl-2"
                style={{ minWidth: "180px", lineHeight: "40px" }}
              >
                <p>
                  <strong>Youtube Link</strong>
                </p>
              </div>
              <div
                className="d-flex align-content-center p-0"
                style={{ flex: 1 }}
              >
                <div
                  className="d-flex align-content-center"
                  style={{ lineHeight: "40px" }}
                >
                  <strong> : </strong>
                </div>
                <div
                  className="d-flex align-content-center"
                  style={{
                    marginLeft: "10px",
                    lineHeight: "27px",
                    flex: 1,
                  }}
                >
                  <div className="w-100">
                    <input
                      value={team.youtube || ""}
                      onChange={(e) => {
                        setTeam({
                          ...team,
                          youtube: e.target.value,
                        });
                        setErrorState({
                          ...errorState,
                          youtubeError: "",
                        });
                      }}
                      className={
                        errorState.youtubeError.length < 1
                          ? "app-input"
                          : "app-input-profile invalid"
                      }
                    />
                    <label className="error-message">
                      {errorState.youtubeError}
                    </label>
                  </div>
                </div>
              </div>
            </Row>

            <Row>
              <div
                className="p-0 pl-2"
                style={{ minWidth: "180px", lineHeight: "40px" }}
              >
                <p>
                  <strong>Website Link</strong>
                </p>
              </div>
              <div
                className="d-flex align-content-center p-0"
                style={{ flex: 1 }}
              >
                <div
                  className="d-flex align-content-center"
                  style={{ lineHeight: "40px" }}
                >
                  <strong> : </strong>
                </div>
                <div
                  className="d-flex align-content-center"
                  style={{
                    marginLeft: "10px",
                    lineHeight: "27px",
                    flex: 1,
                  }}
                >
                  <div className="w-100">
                    <input
                      value={team.website || ""}
                      onChange={(e) => {
                        setTeam({
                          ...team,
                          website: e.target.value,
                        });
                        setErrorState({
                          ...errorState,
                          websiteError: "",
                        });
                      }}
                      className={
                        errorState.youtubeError.length < 1
                          ? "app-input"
                          : "app-input-profile invalid"
                      }
                    />
                    <label className="error-message">
                      {errorState.websiteError}
                    </label>
                  </div>
                </div>
              </div>
            </Row>

            <Row>
              <div
                className="p-0 pl-2"
                style={{ minWidth: "180px", lineHeight: "40px" }}
              >
                <p>
                  <strong>Instagram Link</strong>
                </p>
              </div>
              <div
                className="d-flex align-content-center p-0"
                style={{ flex: 1 }}
              >
                <div
                  className="d-flex align-content-center"
                  style={{ lineHeight: "40px" }}
                >
                  <strong> : </strong>
                </div>
                <div
                  className="d-flex align-content-center"
                  style={{
                    marginLeft: "10px",
                    lineHeight: "27px",
                    flex: 1,
                  }}
                >
                  <div className="w-100">
                    <input
                      value={team.instagram || ""}
                      onChange={(e) => {
                        setTeam({
                          ...team,
                          instagram: e.target.value,
                        });
                        setErrorState({
                          ...errorState,
                          instagramError: "",
                        });
                      }}
                      className={
                        errorState.youtubeError.length < 1
                          ? "app-input"
                          : "app-input-profile invalid"
                      }
                    />
                    <label className="error-message">
                      {errorState.instagramError}
                    </label>
                  </div>
                </div>
              </div>
            </Row>
          </Col>
          <Col
            xs={12}
            xl={5}
            lg={5}
            className="pt-2 pl-1"
            style={{ transform: "translateY(-140px)" }}
          >
            <Row>
              <Col sm={12}>
                <div className="mt-2" style={{ width: "50px" }}>
                  <p>
                    <strong>
                      Overview
                      <span className="ml-1" style={{ color: "red" }}>
                        *
                      </span>
                    </strong>
                  </p>
                </div>
                <div className="mt-2" style={{ flex: 1 }}>
                  <textarea
                    value={team.overview || ""}
                    onChange={(e) => {
                      setTeam({ ...team, overview: e.target.value });
                      setErrorState({ ...errorState, overviewError: "" });
                    }}
                    className={
                      errorState.overviewError.length < 1
                        ? "app-input-bio"
                        : "app-input-bio invalid"
                    }
                  />
                  <div>
                    <label className="error-message">
                      {errorState.overviewError}
                    </label>
                  </div>
                </div>
              </Col>
            </Row>
            {team?.updatedByUserName && (
              <Row>
                <div
                  className="mt-3 p-0 pl-3"
                  style={{ minWidth: "180px", lineHeight: "40px" }}
                >
                  <p>
                    <strong>Last updated by</strong>
                  </p>
                </div>
                <div
                  className="mt-3 d-flex align-content-center p-0"
                  style={{ flex: 1 }}
                >
                  <div
                    className="d-flex align-content-center"
                    style={{ lineHeight: "40px" }}
                  >
                    <strong> : </strong>
                  </div>
                  <div
                    className="d-flex align-content-center"
                    style={{ marginLeft: "10px", lineHeight: "27px", flex: 1 }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        height: "42px",
                        width: "180px",
                        flex: 1,
                      }}
                    >
                      <p className="mb-0">{team?.updatedByUserName}</p>
                    </div>
                  </div>
                </div>
              </Row>
            )}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col xs={12} className="p-0">
            {founders.map((f, index) => (
              <FounderForm
                key={index}
                founder={f}
                onChange={(founder) => {
                  setFounders((ps) => {
                    console.log(index);
                    ps[index] = founder;
                    return [...ps];
                  });
                }}
                onClose={(founder) => {
                  setFounders((ps) => {
                    ps.splice(index, 1);
                    return [...ps];
                  });
                }}
              />
            ))}
          </Col>
          <Col xs={12} className="mt-2" style={{ textAlign: "right" }}>
            <button
              className="app-button-small"
              onClick={() => {
                setFounders((ps) => {
                  ps.push(initialFounder);
                  return [...ps];
                });
              }}
            >
              Add Founder
            </button>
          </Col>
        </Row>
        {state.showAcceptConfirmation && (
          <ConfirmationModal
            loading={loading}
            children={{
              headerText: "Confirm Updates",
              bodyText: <>Are you sure you want to update the content?</>,
              cancelButtonText: "Cancel",
              confirmButtonText: "Update",
              confirmButtonColor: loading ? "grayStatic" : "blue",
            }}
            show={state.showAcceptConfirmation}
            onCancel={() =>
              setState({
                ...state,
                showAcceptConfirmation: false,
              })
            }
            onConfirm={async () => {
              !loading && (await saveTeamData(false));
            }}
          />
        )}
        <ConfirmationModal
          loading={loading}
          children={{
            headerText: "Confirm Publish",
            bodyText: <>Are you sure you want to publish the content?</>,
            cancelButtonText: "Cancel",
            confirmButtonText: "Publish",
            confirmButtonColor: loading ? "grayStatic" : "blue",
          }}
          show={state.showPublishConfirmation}
          onCancel={() =>
            setState({
              ...state,
              showPublishConfirmation: false,
            })
          }
          onConfirm={async () => {
            !loading && (await saveTeamData(true));
          }}
        />
      </Container>
    </>
  );
};

export default TeamProfileEditComponent;
